import React, { useState } from "react";
import { Link } from "react-router-dom"; 
import "./Navbar.css"; 

function Navbar() {
 const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className="navbar-button-container">
        <div className="navbar-inner">
          {/* Left Section */}
          <div className="navbar-left">
          </div>

          {/* Center  Nav*/}
          <div className="navbar-center">
            <Link to="/" className="nav-item">Home</Link>
            <Link to="/projects" className="nav-item">Projects</Link>
            <Link to="/resume" className="nav-item">Resume</Link>
          </div>

          {/* Right Section */}
          <div className="navbar-right">
            <div className="location-info">
              <span></span>
              <span></span>
            </div>
            <Link to="/contact" className="cta-button">Let's Work Together</Link>
          </div>
         

          {/* Mobile Toggle */}
          <button className="mobile-toggle" onClick={toggleMobileMenu}>
            <span>☰</span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={toggleMobileMenu}>
          <div className="mobile-menu-content" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-menu-header">
              <span>Menu</span>
              <button className="mobile-close" onClick={toggleMobileMenu}>✕</button>
            </div>
            <div className="mobile-menu-items">
              <Link to="/" className="mobile-nav-item" onClick={toggleMobileMenu}>Home</Link>
              <Link to="/projects" className="mobile-nav-item" onClick={toggleMobileMenu}>Projects</Link>
              <Link to="/resume" className="mobile-nav-item" onClick={toggleMobileMenu}>Resume</Link>
              <Link to="/contact" className="mobile-cta-button" onClick={toggleMobileMenu}>
                Let's Work Together
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;